<div
    class="preloader"
    [class.fadeout]="showLoader == false && (!cerrixTab || cerrixTab.showLoader == false)"
>
    <div class="fancy-loader"></div>
    @if (cerrixTab) {
        <div class="subtitle">
            {{
                cerrixTab.loadingMessage
                    ? cerrixTab.loadingMessage
                    : ("loadingTab" | t: { name: cerrixTab.name })
            }}
        </div>
    }
    @if (customMessage) {
        <div class="subtitle">{{ customMessage }}</div>
    }
</div>
